/* Vela Nine — free-delivery progress bar in the cart drawer and cart page.
   Reads the real cart total. No fake urgency, no fake stock. */
(function () {
  var THRESHOLD = (window.VELA_FREE_SHIPPING || 0) * 100; // cents
  if (!THRESHOLD) return;

  function money(cents) {
    return '\u20ac' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function paint(cart) {
    var hosts = document.querySelectorAll('cart-drawer .drawer__inner, .cart-drawer .drawer__inner, #main-cart-items');
    hosts.forEach(function (host) {
      var bar = host.querySelector('.vn-ship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'vn-ship';
        bar.innerHTML = '<p class="vn-ship__msg"></p><div class="vn-ship__track"><div class="vn-ship__fill"></div></div>';
        var anchor = host.querySelector('.drawer__cart-items-wrapper') || host.firstElementChild;
        if (anchor) host.insertBefore(bar, anchor); else host.appendChild(bar);
      }
      var remaining = Math.max(0, THRESHOLD - cart.total_price);
      bar.querySelector('.vn-ship__msg').textContent = cart.item_count === 0
        ? 'Free European delivery on orders over ' + money(THRESHOLD) + '.'
        : (remaining > 0
            ? "You're " + money(remaining) + ' away from free European delivery.'
            : 'Free European delivery unlocked.');
      bar.querySelector('.vn-ship__fill').style.width =
        Math.min(100, (cart.total_price / THRESHOLD) * 100) + '%';
    });
  }

  var pending = null;
  function refresh() {
    clearTimeout(pending);
    pending = setTimeout(function () {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {});
    }, 120);
  }

  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[name="add"], .cart-remove-button, .quantity__button, cart-drawer, #cart-icon-bubble')) refresh();
  });
  window.addEventListener('pageshow', refresh);
  refresh();
})();
